<template>
  <div class="card" v-if="item">
    <h3 style="margin-top: 0;font-size: 16px">素材详情</h3>

    <p><strong>姓名：</strong>{{ item.user.name }}</p>
    <p><strong>部门：</strong>{{ item.user.dept }}</p>
    <p><strong>提交时间：</strong>{{ item.created_at }}</p>

    <p style="margin-top:8px"><strong>素材内容：</strong></p>
    <p>{{ item.content }}</p>

    <div class="img-grid" style="margin-top:12px">
      <img v-for="(u,i) in item.image_urls" :key="i" :src="u" />
    </div>

    <div style="margin-top:16px">
      <router-link to="/material" class="button">返回</router-link>
    </div>
  </div>
</template>

<script>
import {getMyMaterials } from '../api/material'

export default {
  name: "MaterialDetail",

  data() {
    return {
      item: null
    }
  },

  async created() {
    // Vue2 用 this.$route 获取路由
    const id = Number(this.$route.params.id)

    const list = await getMyMaterials()
    this.item = list.find(x => x.id === id)
  }
}
</script>

<style scoped>
/* 你的样式依然可写在这里 */
</style>
